<div class="timeline-container">
  <div class="timeline-left">
    <div class="time-display">
      <span class="time-value">{{ zamanFormatla(simZaman) }}</span>
      <span class="time-label">/ {{ zamanFormatla(maxZaman) }}</span>
    </div>

    <div class="progress-container">
      <div class="progress-bar"
           #progressBar
           (mousedown)="onScrubStart($event)"
           [class.scrubbing]="scrubbing">
        <div class="progress-fill" [style.width.%]="zamanYuzdesi">
          <div class="progress-thumb" [class.aktif]="scrubbing"></div>
        </div>

        <ng-container *ngFor="let olay of tumOlaylar; trackBy: olayTrackBy">
          <div
            class="event-marker"
            [class.gecmis]="simZaman >= olay.zaman"
            [style.left]="olayPozisyonuAl(olay.zaman)"
            [style.--marker-renk]="olay.renk || olayRengiAl(olay.tip)"
            nz-tooltip
            [nzTooltipTitle]="olayTooltip"
            [nzTooltipPlacement]="'top'"
            (click)="olayaAtla(olay); $event.stopPropagation()">
            <ng-template #olayTooltip>
              <div class="olay-tooltip">
                <i nz-icon [nzType]="olayIkonuAl(olay.tip)" class="olay-tooltip-ikon"
                   [style.color]="olay.renk || olayRengiAl(olay.tip)"></i>
                <span>{{ olay.aciklama || olay.etiket }}</span>
                <span class="olay-tooltip-zaman">{{ zamanFormatla(olay.zaman) }}</span>
              </div>
            </ng-template>
          </div>
        </ng-container>

        <div class="snapshot-markers">
          <div *ngFor="let entry of snapshotEntries; trackBy: snapshotTrackBy"
               class="snapshot-tick"
               [style.left.%]="(entry[0] / maxZaman) * 100"
               nz-tooltip
               [nzTooltipTitle]="'Snapshot @ ' + zamanFormatla(entry[0]) + ' | Dolum: %' + (entry[1].dolumYuzdesi | number:'1.0-0')">
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="timeline-center">
    <nz-select
      [(ngModel)]="seciliSenaryo"
      (ngModelChange)="senaryoSec($event)"
      class="scenario-select"
      [nzCustomTemplate]="scenarioTemplate">
      <nz-option
        *ngFor="let senaryo of senaryolar"
        [nzValue]="senaryo"
        [nzLabel]="senaryo.ad"
        [nzCustomContent]="true">
        <i nz-icon [nzType]="senaryo.ikon"></i>
        <span>{{ senaryo.ad }}</span>
      </nz-option>
    </nz-select>

    <ng-template #scenarioTemplate let-selected>
      <i nz-icon [nzType]="selected.nzValue?.ikon || 'setting'"></i>
      {{ selected.nzLabel }}
    </ng-template>
  </div>

  <div class="timeline-right">
    <div class="speed-controls">
      <button
        *ngFor="let hizOpt of hizSecenekleri"
        nz-button
        nzSize="small"
        [nzType]="simHizi === hizOpt.deger ? 'primary' : 'default'"
        (click)="hizAyarla(hizOpt.deger)"
        class="speed-btn">
        {{ hizOpt.etiket }}
      </button>
    </div>
  </div>
</div>
